import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalPages: 0,
  entities: [],
  exportData: [],
  allCountryList: null,
  // countryList: [],
  countryDropdownList: [],
  currencyDropdownList: [],
  companyDropdownList: [],
  tounamentUsers: [],
  pointSummary: [],
  tournamentForEdit: {},
  tournamentRules: null,
  rulesFetched: {},
  tournamentPointPool: null,
  tournamentPrizePool: null,
  lastError: null,
  contestUsers: [],
  tournamentList: [],
  tournamentsCount: 0,
  contestData: {},
  acceptedUserList: [],
  allocatedUserList: [],
  bracketsImages: {},
  // rankSummaryTournaments: {},
  rankSummaryUserListing: [],
  // pointSummaryTournaments: {},
  pointSummaryUserListing: [],
  singleCompanyFetched: [],
  singleCompanyId: null,
  gameList: [],
  tournamentIdList: [],
  tounamentUsers: [],
  tounamentUsers1: [],
  tournamentReportData: {
    entities: [],
    totalCount: 0,
  },
  pointSummaryActionsLoading: false,
  roundCount: 0,
  totalContest: 0,
  totalFullContest: 0,
  cancelReason: [],
  staffUserList: [],
};
export const callTypes = {
  list: "list",
  action: "action",
};
export const tournamentsSlice = createSlice({
  name: "tournaments",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
      // state.pointSummaryActionsLoading = false;
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // singleItemFetched
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.tournamentForEdit = action.payload.tournamentForEdit;
      state.error = null;
    },
    roundsItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.tournamentRounds = action.payload.tournamentRounds;
      state.error = null;
    },
    rulesFetched: (state, action) => {
      state.actionsLoading = false;
      state.tournamentRules = action.payload.tournamentRules;
      state.error = null;
    },
    pointPoolFetched: (state, action) => {
      state.actionsLoading = false;
      state.tournamentPointPool = action.payload.tournamentPointPool;
      state.error = null;
    },
    prizePoolFetched: (state, action) => {
      state.actionsLoading = false;
      state.tournamentPrizePool = action.payload.tournamentPrizePool;
      state.error = null;
    },
    contestUsersList: (state, action) => {
      const { contestUsers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestUsers = contestUsers;
    },
    contestsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    acceptedUserList: (state, action) => {
      const { acceptedUserList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.acceptedUserList = acceptedUserList;
    },
    allocatedUserList: (state, action) => {
      const { allocatedUserList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.allocatedUserList = allocatedUserList;
    },
    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryList = countryList;
    },

    CountryDropdownList: (state, action) => {
      // console.log('CountryDropdownList action called', action);
      const { countryDropdownList } = action.payload;

      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },

    CompanyDropdownList: (state, action) => {
      // console.log('companyDropdownList action called', action);
      const { companyDropdownList } = action.payload;

      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyDropdownList = companyDropdownList;
    },

    CurrencyList: (state, action) => {
      const { currencyList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.currencyList = currencyList;
    },

    CurrencyDropdownList: (state, action) => {
      const { currencyDropdownList } = action.payload;

      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.currencyDropdownList = currencyDropdownList;
    },

    // singleItemFetched
    fetchPointSummaryFetched: (state, action) => {
      state.actionsLoading = false;
      state.pointSummaryActionsLoading = false;
      state.pointSummary = action.payload.pointSummary;
      state.tounamentUsers = action.payload.tounamentUsers;
      state.error = null;
    },
    tournamentslist: (state, action) => {
      const { tournamentslistlist } = action.payload;
      // console.log("totalCount, entities slice",tournamentslistlist)
      state.listLoading = false;
      state.error = null;
      state.entities = tournamentslistlist.tournaments;
      state.tournamentList = tournamentslistlist.tournaments;
      state.totalCount = tournamentslistlist.totalRecord;
      state.totalPages = tournamentslistlist.totalPages;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
    gameTypeList: (state, action) => {
      const { gameTypeData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameTypeData = gameTypeData;
    },
    tournamentIdList: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.tournamentIdList = entities;
    },
    // listFetched
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
      // state.entities = [];
    },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
    },
    // itemDeleted
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    contestData: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.contestData = action.payload?.contestData;
    },
    // itemsDeleted
    itemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => !action.payload.ids.includes(el.id)
      );
    },
    // itemStatusUpdated
    itemStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    uploadBracketsImage: (state, action) => {
      // console.log(state);
      state.error = null;
      state.bracketsImages = action.payload;
    },
    rankSummaryData: (state, action) => {
      state.error = null;
      // state.rankSummaryTournaments = action.payload.item;
      state.rankSummaryUserListing = action.payload.tounamentUsers;
    },
    pointSummaryData: (state, action) => {
      state.error = null;
      // state.pointSummaryTournaments = action.payload.item;
      state.pointSummaryUserListing = action.payload.tounamentUsers;
    },

    singleCompanyFetched: (state, action) => {
      // console.log("action.payload",action.payload.singleCompanyFetched)
      state.actionsLoading = false;
      state.singleCompanyFetched = action.payload.singleCompanyFetched;
      state.singleCompanyId = action.payload.singleCompanyId;
      state.error = null;
    },
    fetchRankSummaryFetched: (state, action) => {
      state.actionsLoading = false;
      state.pointSummary = action.payload.pointSummary;
      state.tounamentUsers = action.payload.tounamentUsers;
      state.tounamentUsers1 = action.payload.tounamentUsers1;
      state.error = null;
    },
    TournamentReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.tournamentReportData.entities = entities;
      state.tournamentReportData.totalCount = totalCount;
    },
    startPointSummaryCall: (state, action) => {
      state.error = null;
      state.pointSummaryActionsLoading = true;
    },
    endPointSummaryCall: (state, action) => {
      state.error = null;
      state.pointSummaryActionsLoading = false;
    },
    tournamentRoundCount: (state, action) => {
      state.error = null;
      state.roundCount = action.payload;
    },
    tournamentContestCount: (state, action) => {
      state.error = null;
      state.totalContest = action.payload;
    },
    tournamentFullContestCount: (state, action) => {
      state.error = null;
      state.totalFullContest = action.payload;
    },
    tournamentCancellationReason: (state, action) => {
      state.error = null;
      state.cancelReason = action.payload;
    },
    staffUsersFetched: (state, action) => {
      const { entities } = action.payload;
      state.error = null;
      state.staffUserList = [{user: {name: 'All', _id: "all"}}, ...entities];
    },
  },
});
